export default __webpack_public_path__ + "static/media/ic-bin-gray-24-px.e5a3c36c.svg";